import React from 'react';
import './kick-start.css';

const m_attend = () => {
    return (
        <div className="m_attend__wrap">
            <div className="m_learning container">
                <h3 className="m_learning--title">Why Attend?</h3>
                <p className="m_learning--text inner_pages--text">Accelerate and broaden your knowledge of key areas in data science, including deep learning, machine learning, and predictive analytics.</p>
                <p className="m_learning--text inner_pages--text">With numerous introductory level workshops, you get hands-on experience to quickly build up your skills.</p>
                <p className="m_learning--text inner_pages--text">Take time out of your busy schedule to accelerate your knowledge of the latest advances in data science.</p>
                <p className="m_learning--text inner_pages--text">Learn directly from world-class instructors who are the authors and contributors to many of the tools and languages used in data science today.</p>
                <p className="m_learning--text inner_pages--text">Meet companies ranging from hot startups to Fortune 500s looking to hire professionals with data science skills at all levels.</p>
                <p className="m_learning--text inner_pages--text">Network at our numerous lunches and events to meet data scientists, enthusiasts, and business professionals.</p>
                <p className="m_learning--text inner_pages--text">Get access to other focus area content including ML / DL, Data Visualization, Quant finance.</p>
            </div>
        </div>
    );
};

export default m_attend;